function resolveColors(event, element) {
  const detail = event?.detail || event?.originalEvent?.detail || {};
  const pickerColor =
    detail.color ?? element?.dataset?.wysiwygPickerColor ?? element?.dataset?.wysiwygBackgroundColor;
  const fallbackColor = detail.fallbackColor ?? element?.dataset?.wysiwygBackgroundColor;

  return {
    pickerColor: pickerColor || fallbackColor || "",
    fallbackColor: fallbackColor || "",
  };
}

function applyWysiwygBackground($textarea, event) {
  const colors = resolveColors(event, $textarea[0]);
  const $editor = $textarea.siblings(".note-editor");

  if ($editor.length) {
    $editor.css("background-color", colors.fallbackColor);
    $editor.find(".note-editable").css("background-color", colors.pickerColor);
  } else {
    $textarea.css("background-color", colors.pickerColor);
  }
}

function bindBackgroundUpdates($textarea) {
  $textarea.off("wysiwyg:background-change.summernoteBackground");
  $textarea.on("wysiwyg:background-change.summernoteBackground", function (event) {
    applyWysiwygBackground($textarea, event);
  });
}

$(document).on("turbo:load data-remote-target-refresh", function () {
  font_sizes = [];

  for (let size = 8; size < 151; size++) {
    font_sizes[font_sizes.length] = size.toString();
  }

  font_names = [
    "Arial Black",
    "Arial",
    "Comic Sans MS",
    "Courier New",
    "GT Planar Italic 45",
    "GT Planar Retalic 45",
    "GT Planar",
    "Helvetica Neue",
    "Helvetica",
    "Impact",
    "LiberationSans",
    "Lucida Grande",
    "Oswald",
    "Rajdhani",
    "Saira",
    "Tahoma",
    "Times New Roman",
    "TT Commons pro Thin",
    "TT Commons pro ExtraLight",
    "TT Commons pro Light",
    "TT Commons pro",
    "TT Commons pro Narrow",
    "TT Commons pro Medium",
    "TT Commons pro DemiBold",
    "TT Commons pro ExtraBold",
    "TT Commons pro Black",
    "TT Commons pro ExtraBlack",
    "Ubuntu",
    "Verdana",
  ];

  additional_fonts = ["GT-Walsheim", "Montserrat", "Wasa"];

  if (typeof document.body.dataset.googleFonts != "undefined") {
    additional_fonts = additional_fonts.concat(
      JSON.parse(document.body.dataset.googleFonts)
    );
  }

  font_names = font_names.concat(additional_fonts);

  $("textarea.wysiwyg").each(function () {
    const $textarea = $(this);

    if ($textarea.data("summernote")) {
      return;
    }

    bindBackgroundUpdates($textarea);

    $textarea.summernote({
      lang: "en-EN",
      minHeight: 200,
      maxHeight: 500,
      fontNames: font_names,
      fontNamesIgnoreCheck: additional_fonts,
      fontSizes: font_sizes,
      toolbar: [
        ["style", ["style"]],
        ["font", ["bold", "italic", "underline", "clear"]],
        ["fontname", ["fontname", "fontsize", "height"]],
        ["color", ["color"]],
        ["para", ["ul", "ol", "paragraph"]],
        ["table", ["table"]],
        ["insert", ["link", "picture", "video"]],
      ],
      callbacks: {
        onInit: function () {
          applyWysiwygBackground($textarea);
        },
      },
    });
  });
});
